<template>
  <form @submit.prevent="updateReport">
    <card id="evaluations" ref="evaluationref">
        <div slot="header">
          <h3 class="card-reference pull-right">Reference Nr: <b>{{ model.user.reference_nr }}</b></h3>
          <h2 class="card-title pull-left">Screening Report</h2>
        </div>
        <div v-if="initialized" class="row">
          <div class="col-12">
            <table class="table-bordered table-top-info">
              <tbody>
                <tr>
                  <td>
                    <h4 class="mb-1">Grid completed by:</h4>
                    <p class="mb-1">{{ model.evaluator.name }}</p>
                    <p>{{ model.submitted_at }}</p>
                  </td>
                  <td>
                    <h4>ADMISSIBILITY ELIGIBILITY CHECK</h4>
                    <div class="mt-3">
                      <radio name="model.admissibility"
                             class="form-check-inline"
                             value="accepted"
                             :disabled="!isEditable"
                             v-model="model.admissibility"
                      >
                        <label>Accepted</label>
                      </radio>
                    </div>
                    <div>
                      <radio name="model.admissibility"
                             class="form-check-inline"
                             value="rejected"
                             :disabled="!isEditable"
                             v-model="model.admissibility"
                      >
                        <label>Rejected</label>
                      </radio>
                    </div>
                  </td>
                  <td>
                    <upload-file
                      v-if="initialized"
                      v-model="model.files.evaluation_data.eligibility_report"
                      class="upload-file"
                      :file-data="model.files.evaluation_data.eligibility_report"
                      :is-editable="isEditable"
                      :is-summary="true"
                      select-text="UPLOAD ELIGIBILITY REPORT"
                      section="evaluation_data.eligibility_report"
                      >
                    </upload-file>
                  </td>
                </tr>
              </tbody>
            </table>
            <card card-body-classes="table-full-width">
              <div class="col-lg-6">
                <h4 class="card-title">1. Title:</h4>
                <div class="form-group">
                  <textarea
                    class="form-control"
                    name="evaluation_data.title"
                    v-model="model.evaluation_data.title"
                    :disabled="!isEditable"
                    :error="getError('evaluation_data.title')"
                    v-validate="'required'"
                    placeholder="Insert application title"
                  >
                  </textarea>
                </div>
                <h4 class="card-title">2. Name of the lead applicant:</h4>
                <div class="form-group">
                  <textarea
                    class="form-control"
                    name="evaluation_data.lead_applicant_name"
                    v-model="model.evaluation_data.lead_applicant_name"
                    :disabled="!isEditable"
                    :error="getError('evaluation_data.lead_applicant_name')"
                    v-validate="'required'"
                    placeholder="Insert name of organisation"
                  >
                  </textarea>
                </div>
                <h4 class="card-title">3. Type of organisation</h4>
                <div class="form-group">
                  <h6>
                    Select the one which applies to your organisation, see the Guidelines for Applicants for further details.
                  </h6>
                  <div class="mt-4"></div>
                  <base-checkbox name="checkbox" :disabled="!isEditable" v-model="model.evaluation_data.organization_type.non_governmental_organisation">
                    Non-Governmental Organisation (NGO) / Civil Society Organisation (CSO) / Community-based Organisation (CBO) / Local non-profit organisation
                  </base-checkbox>
                  <base-checkbox name="checkbox" :disabled="!isEditable" v-model="model.evaluation_data.organization_type.small_socio_professional_organisation">
                    Small socio-professional organisation/ small for-profit organisation (5-10 permanent staff, balance or turnover &lt;2M €) Individual consultants are not eligible as lead applicant, they can be sub-contractant for supporting local organisations
                  </base-checkbox>
                  <base-checkbox name="checkbox" :disabled="!isEditable" v-model="model.evaluation_data.organization_type.sub_national_local_authorities_of_ors">
                    Sub-national local authorities of ORs (municipalities, cities, municipal and intermunicipal services
                  </base-checkbox>
                  <base-checkbox name="checkbox" :disabled="!isEditable" v-model="model.evaluation_data.organization_type.local_government_departments">
                    Local government departments
                  </base-checkbox>
                  <base-checkbox name="checkbox" :disabled="!isEditable" v-model="model.evaluation_data.organization_type.national_or_local_research_organisation">
                    National or local research organisation
                  </base-checkbox>
                </div>
                <div class="mt-3">
                  <h4 class="card-title d-inline-block mr-3">4. Co-applicant if any</h4>
                  <radio name="model.evaluation_data.has_co_applicant"
                         class="form-check-inline"
                         value="YES"
                         :disabled="!isEditable"
                         v-model="model.evaluation_data.has_co_applicant"
                  >
                    <label>YES</label>
                  </radio>
                  <radio name="model.evaluation_data.has_co_applicant"
                         class="form-check-inline"
                         value="NO"
                         :disabled="!isEditable"
                         v-model="model.evaluation_data.has_co_applicant"
                  >
                    <label>NO</label>
                  </radio>
                </div>
                <div class="form-group">
                  <textarea
                    class="form-control"
                    name="evaluation_data.name_of_co_applicants"
                    v-model="model.evaluation_data.name_of_co_applicants"
                    :error="getError('evaluation_data.name_of_co_applicants')"
                    :disabled="model.evaluation_data.has_co_applicant === 'NO'"
                    v-validate="'required'"
                    placeholder=""
                  >
                  </textarea>
                </div>

                <h4 class="card-title">5. BEST 2.0+ Objectives chosen</h4>
                <div class="form-group">
                  <base-checkbox name="checkbox" :disabled="!isEditable" v-model="model.evaluation_data.objectives.conservation_of_biodiversity">
                    Conservation of biodiversity and ecosystem services
                  </base-checkbox>
                  <base-checkbox name="checkbox" :disabled="!isEditable" v-model="model.evaluation_data.objectives.sustainable_use_of_biodiversity">
                    Sustainable use of biodiversity, natural resources and ecosystem services
                  </base-checkbox>
                  <base-checkbox name="checkbox" :disabled="!isEditable" v-model="model.evaluation_data.objectives.ecosystem_based_climate">
                    Ecosystem-based climate change mitigation and adaptation
                  </base-checkbox>
                </div>


                <h4 class="card-title">6. Grant amount requested</h4>
                <div class="form-group">
                  <currency-input
                    class="form-control"
                    name="evaluation_data.grant_amount_requested"
                    v-model="model.evaluation_data.grant_amount_requested"
                    :error="getError('evaluation_data.grant_amount_requested')"
                    :disabled="!isEditable"
                    currency="EUR"
                    locale="de"
                    v-validate="'required'"
                    placeholder=""
                  />
                </div>

                <h4 class="card-title">7. ESMS review result - RISK LEVEL</h4>
                <div class="form-group">
                  <div class="mt-3">
                    <radio name="evaluation_data.esms_review"
                           class="form-check-inline"
                           value="high"
                           :disabled="!isEditable"
                           v-model="model.evaluation_data.esms_review"
                    >
                      High
                    </radio>
                  </div>
                  <div class="mt-3">
                    <radio name="evaluation_data.esms_review"
                           class="form-check-inline"
                           value="medium"
                           :disabled="!isEditable"
                           v-model="model.evaluation_data.esms_review"
                    >
                      Medium
                    </radio>
                  </div>
                  <div class="mt-3">
                    <radio name="evaluation_data.esms_review"
                           class="form-check-inline"
                           value="low"
                           :disabled="!isEditable"
                           v-model="model.evaluation_data.esms_review"
                    >
                      Low
                    </radio>
                  </div>
                </div>
                <div class="form-group">
                  <span class="file-caption" v-if="!model.files.evaluation_data.esms_evaluation_report">UPLOAD ESMS EVALUATION REPORT</span>
                  <upload-file
                    v-if="initialized"
                    v-model="model.files.evaluation_data.esms_evaluation_report"
                    class="upload-file"
                    :file-data="model.files.evaluation_data.esms_evaluation_report"
                    :is-editable="isEditable"
                    :is-summary="true"
                    section="evaluation_data.esms_evaluation_report"
                    >
                  </upload-file>
                </div>

                <h4 class="card-title">8. Due Diligence result</h4>
                <div class="form-group">
                  <div class="mt-3">
                    <radio name="evaluation_data.due_diligenc"
                           class="form-check-inline"
                           value="high"
                           :disabled="!isEditable"
                           v-model="model.evaluation_data.due_diligenc"
                    >
                      High
                    </radio>
                  </div>
                  <div class="mt-3">
                    <radio name="evaluation_data.due_diligenc"
                           class="form-check-inline"
                           value="medium"
                           :disabled="!isEditable"
                           v-model="model.evaluation_data.due_diligenc"
                    >
                      Medium
                    </radio>
                  </div>
                  <div class="mt-3">
                    <radio name="evaluation_data.due_diligenc"
                           class="form-check-inline"
                           value="low"
                           :disabled="!isEditable"
                           v-model="model.evaluation_data.due_diligenc"
                    >
                      Low
                    </radio>
                  </div>
                </div>
                <div class="form-group">
                  <span class="file-caption" v-if="!model.files.evaluation_data.dd_evaluation_report">UPLOAD DUE DILIGENCE EVALUATION REPORT</span>
                  <upload-file
                    v-if="initialized"
                    v-model="model.files.evaluation_data.dd_evaluation_report"
                    class="upload-file"
                    :file-data="model.files.evaluation_data.dd_evaluation_report"
                    :is-editable="isEditable"
                    :is-summary="true"
                    section="evaluation_data.dd_evaluation_report"
                    >
                  </upload-file>
                </div>
              </div>
            </card>
            <div v-if="isEditable" class="card-footer">
              <slot name="footer">
                <div class="pull-right">
                  <base-button wide @click.native="submitReport">SUBMIT</base-button>
                </div>

                <div class="pull-left">
                  <base-button
                    wide
                    type="primary"
                    native-type="submit"
                  >
                    SAVE PROGRESS
                  </base-button>
                </div>
                <div class="clearfix"></div>
              </slot>
            </div>
          </div>
        </div>
    </card>
  </form>
</template>
<script>
  import swal from 'sweetalert2';
  import {Table, TableColumn, Select, Option} from 'element-ui';
  import {BasePagination, Modal, GenerateReports} from 'src/components';
  import {SummaryService, FileUploadService} from '@/services';

  export default {
    components: {
      GenerateReports,
      BasePagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Modal
    },
    data() {
      return {
        initialized: false,
        isEditable: true,
        summaryId: parseInt(this.$route.params.summaryId),
        userDetails: {},
        loggedUser: {},
        documents: {},
        applicantData: {},
        model:
        {
          evaluation_data: {
            objectives: {},
            organization_type: {},
            has_co_applicant: 'NO',
          },
          files: {
            evaluation_data: {}
          },
          user: {},
          evaluator: {},
          status: 'DRAFT',
          submitted_at: '',
          updated_at: '',
        },
        modalEvaluate: {
          visibility: false,
          application: {}
        }
      };
    },
    methods: {
      async getSummaryReport(summaryId)
      {
        let vm = this;

        await SummaryService.getSummaryReport(summaryId).then(function (response)
        {
          let model = {...vm.model, ...response.data};

          model.evaluation_data.lead_applicant_name = model.evaluation_data.lead_applicant_name || model.user.name;
          model.evaluation_data = {...vm.model.evaluation_data, ...response.data.evaluation_data};

          vm.model = model;

          if (model.status === 'SUBMITTED')
          {
            vm.isEditable = false;
          }
        });
      },
      async getItems(page) {
        let vm = this;
        let loader = vm.$loading.show();

        await vm.getSummaryReport(vm.summaryId);

        loader.hide();
      },
      async updateReport()
      {
        let vm = this;
        let isValidForm = true;

        if (isValidForm) {
          let loader = this.$loading.show();
          let updateRequest = SummaryService.updateSummaryReport(vm.model, vm.summaryId);

          await updateRequest.then(() => {
            this.$store.dispatch('Auth/init');
            LocalizationService.init();

          }).catch(() => {

          });

          await vm.uploadFiles();
          loader.hide();

          if (vm.model.status === 'SUBMITTED') {
            await this.showNotification('complete-progress');
            vm.isEditable = false;
          } else {
            await this.showNotification('save-progress');
          }

        }
      },
      async submitReport()
      {
        let vm = this;

        var submitConfirmation = await vm.showPreSubmitNotification().then((result) => {
          return result.value ? true : false;
        });

        if (submitConfirmation) {

          vm.model.status = 'SUBMITTED';

          await vm.updateReport();

          await SummaryService.submitSummaryReport(vm.summaryId).then(() =>
          {
            this.$store.dispatch('Auth/init');
            LocalizationService.init();

          }).catch(() => {

          });
        }
      },
      async uploadFiles() {
        let files = this.model.files;
        let promises = [];

        for (var section in files) {
          if (files.hasOwnProperty(section)) {

            for (var subSection in files[section]) {
              if (files[section].hasOwnProperty(subSection)) {

              let fileToUpload = files[section][subSection];
              if (fileToUpload instanceof File) {

                let formData = new FormData();
                formData.append('file', fileToUpload);
                formData.append('section', fileToUpload.section);
                formData.append('$section', section);
                if (fileToUpload.id) {
                  formData.append('id', fileToUpload.id);
                }

                let promise = FileUploadService.uploadSummaryFile({
                  summaryId: this.summaryId,
                  formData: formData
                }).then(function (response) {
                  let fdSection = formData.get('$section');
                  let fdSubSection = formData.get('$subSection');

                  files[fdSection][subSection] = {
                    id: response.data.id,
                    name: response.data.filename,
                    download: response.data.download
                  };

                }).catch(function (error) {
                  console.log('err', error);
                })

                promises.push(promise);
              }
            }
            }
          }
        }

        return await Promise.all(promises);
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      showPreSubmitNotification() {
        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: 'You are about to submit your Screening Report, are you sure?<br />Once you click YES, you cannot go back.',
          // html: this.$t('general.notification__pre_submit_evaluation').split("\n").join("<br>"),
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: 'YES',
          cancelButtonClass: 'ml-3 btn btn-danger btn-fill',
          cancelButtonText: 'NO',
        })
      },

      async showNotification(type) {
        if (type === 'save-progress') {
          return await swal({
            title: this.$t('general.notification__success'),
            html: 'Your Screening Report has been Saved.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary btn-fill',
            type: 'success'
          });
        } else if (type === 'complete-progress') {
          return await swal({
            title: this.$t('general.notification__success'),
            html: 'Your Screening Report has been Saved.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary btn-fill',
            type: 'success'
          });
        }
      },
    },
    beforeMount()
    {
      let vm = this;

      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
    },
    mounted() {
      let vm = this;
      vm.getItems();

      vm.initialized = true;
    }
  };
</script>
<style lang="scss" scoped>
  .card-body {
    button {
      margin-left: 1rem;
    }
  }

  button {
    white-space: nowrap;
  }

  .evaluations-list {
    list-style-type: disc !important;
  }

  .table-top-info
  {
    td
    {
      padding: 10px 20px;
    }
  }
</style>
